import proxy from "../proxy";
const transport = {
  list:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("transport/list", data, { dispatch }),
  info:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("transport/info", data, { dispatch }),
  update:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.put("transport/update", data);
      await proxy.get("transport/list", data2, { dispatch });
    },
  add:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.post("transport/add", data);
      await proxy.get("transport/list", data2, { dispatch });
    },
  setTransport:
    (data = {}, data2 = {}, data3 = {}) =>
    async (dispatch) => {
      await proxy.post("transport/setTransport", data);
      await proxy.get("userFactor/info", data2, { dispatch });
    },
  del:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.delete("transport/delete", data);
      await proxy.get("transport/list", data2, { dispatch });
    },
};

export default transport;
